module.exports = __webpack_public_path__ + "img/apple-music.12e99c2a.svg";